import type { Faq } from '../entities/faq.entity'
import type { FaqRepository } from '../repositories/faq_repository'

export class GetFaqByIdUseCase {
  constructor(private readonly repository: FaqRepository) {}

  execute(id: string): Promise<Faq> {
    return this.repository.getById(id)
  }
}
